export default __webpack_public_path__ + "static/media/security.4781789c.png";